import { render, staticRenderFns } from "./CreatingOrdersScreen.vue?vue&type=template&id=b3d3de8c&scoped=true"
import script from "./CreatingOrdersScreen.vue?vue&type=script&lang=js"
export * from "./CreatingOrdersScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d3de8c",
  null
  
)

export default component.exports